import { IonBadge, IonCol, IonIcon, IonLabel, IonRange } from '@ionic/react';
import { checkboxOutline, squareOutline } from 'ionicons/icons';
import React from 'react';
import { Flip } from 'react-toastify';
import { copyTextToClipboard } from '../../common/util';
import { useToast } from '../../providers/ToastProvider';
import { IonItemWrapper } from './FIeldDetailRow.styles';

interface IFieldDetailRow {
  value: string | number | boolean;
  title?: string;
  icon?: string;
  label?: string;
  labelIcon?: string;
  lines?: boolean;
  onClick?: (e: React.MouseEvent, val: string | number | boolean) => void;
  copyToClipboard?: boolean;
  isButton?: boolean;
  isRange?: boolean;
  placeholder?: string;
}

const FieldDetailRow: React.FC<IFieldDetailRow> = ({ value, title, icon, label, labelIcon, lines, onClick, copyToClipboard, isButton, isRange, placeholder = '' }) => {
  const {
    actions: { infoToast },
  } = useToast();

  switch (typeof value) {
    case 'string':
      value = value || '';
      break;
    case 'boolean':
      value = value || false;
      break;
    case 'number':
      value = value || '';
      break;
    default:
      value = value || '';
  }

  const handleClick = (e: React.MouseEvent) => {
    if (copyToClipboard && value) {
      copyTextToClipboard(value.toString());
      infoToast('Copied to clipboard', 1000, Flip);
    }
    onClick && onClick(e, value);
  };

  return (
    <IonItemWrapper className="ion-no-padding" button={isButton || false} onClick={handleClick} lines={lines === undefined || lines ? 'full' : 'none'}>
      {/* icon */}
      {(icon || icon === '') && <IonIcon color="medium" icon={icon} size="small" slot="start" className="ion-no-margin"></IonIcon>}
      {/* title */}
      {title && (
        <IonCol sizeXs="5" sizeSm="3" sizeMd="3" sizeLg="3" sizeXl="2">
          <IonBadge color="light">
            <IonLabel color="medium">{title}</IonLabel>
          </IonBadge>
        </IonCol>
      )}
      {/* value not boolean */}
      {typeof value !== 'boolean' && (
        <IonCol size="auto" className={icon ? 'ion-margin-start' : ''}>
          {value && <IonLabel className="ion-text-wrap">{value}</IonLabel>}
          {!value && (
            <IonLabel className="ion-text-wrap" color="medium">
              {placeholder}
            </IonLabel>
          )}
        </IonCol>
      )}
      {/* value boolean */}
      {typeof value === 'boolean' && (
        <IonCol className={icon ? 'ion-margin-start' : ''}>
          <IonLabel>{value === true ? <IonIcon icon={checkboxOutline} /> : <IonIcon icon={squareOutline} />}</IonLabel>
        </IonCol>
      )}
      {/* value number slider */}
      {typeof value === 'number' && isRange && (
        <IonCol className={icon ? 'ion-margin-start' : ''}>
          <IonRange className="ion-no-padding" ticks snaps value={value} />
        </IonCol>
      )}
      {/* label */}
      {label && (
        <IonLabel color="medium" slot="end">
          {label}
        </IonLabel>
      )}
      {/* labelIcon */}
      {labelIcon && <IonIcon color="medium" icon={labelIcon} size="small" slot="end"></IonIcon>}
    </IonItemWrapper>
  );
};

export default FieldDetailRow;
